<nav
	[sextant]="'menu'"
	class="navbar navbar-expand-lg navbar-dark bg-dark"
	*ngIf="authService.isAnyGranted"
>
	<a class="navbar-brand">
		<img alt="ukit" src="/img/logo.svg" style="height: 30px; margin-top: -4px;">
	</a>
	
	<button
		class="navbar-toggler navbar-toggler-right"
		type="button"
		(click)="navbarCollapsed = !navbarCollapsed"
		[attr.aria-expanded]="!navbarCollapsed"
		aria-controls="navbarSupportedContent"
		aria-expanded="false"
		aria-label="Toggle navigation"
	>
		<span class="navbar-toggler-icon"></span>
	</button>
	
	<div
		class="collapse navbar-collapse"
		[ngbCollapse]="navbarCollapsed"
		id="navbarSupportedContent"
	>
		<ul
			class="navbar-nav mr-auto"
			*ngFor="let node of nodes; let i = index"
		>
			<li
				ngbDropdown
				class="nav-item dropdown"
				*ngIf="!node.isHidden && isAnyChildrenAllow(node)"
			>
				<a
					class="nav-link"
					[id]="'navbarDropdown' + i"
					[attr.data-parent]="node.route"
					[sextant]="'parent-' + node.route"
					ngbDropdownToggle
					role="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					style="cursor: pointer;"
				>
					{{ node.i18n | translate }}
				</a>
				
				<div
					ngbDropdownMenu
					class="dropdown-menu"
					[attr.aria-labelledby]="'navbarDropdown' + i"
				>
					<ng-container *ngFor="let _node of node.childs">
						<ng-container *ngIf="!_node.isHidden && isAllow(_node)">
							<a
								*ngIf="_node.route; else externalRouteLink"
								routerLink="{{ [ _node.route ] }}"
								[attr.data-report]="_node.route"
								[sextant]="'report-' + _node.route"
								[class]="currentMenuItem == _node.route ? 'dropdown-item active' : 'dropdown-item'"
								(click)="navbarCollapsed = true"
								[target]="_node.target || null"
								ngbDropdownItem
							>
								{{ _node.i18n | translate }}
							</a>
							
							<ng-template #externalRouteLink>
								<a
									[href]="_node.url"
									[class]="'dropdown-item'"
									target="_blank"
								>
									{{ _node.i18n | translate }}
								</a>
							</ng-template>
						</ng-container>
					</ng-container>
				</div>
			</li>
		</ul>
		
		<ul class="navbar-nav ml-auto">
			<li [sextant]="'user-email'">
				<a class="nav-link">
					{{ authService.email }}
				</a>
			</li>
			
			<li>
				<a
					class="nav-link"
					(click)="onSignOut()"
					[sextant]="'logout'"
				>
					<i class="fa fa-sign-out-alt" aria-hidden="true"></i>
				</a>
			</li>
		</ul>
	</div>
</nav>

<br/>

<div [class]="getContainerClass()">
	<router-outlet></router-outlet>

	<simple-notifications
		[options]="options"
		[class]="'max-z-index'"
	></simple-notifications>
</div>
